export default function() {
  return (Math.random() - 0.5) * 1e-6;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-force/src/jiggle.js
// module id = 66
// module chunks = 0 1 2 3 4